(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('showOnHeightDiffDepartments', showOnHeightDiffDepartments);

    function showOnHeightDiffDepartments($timeout) {
        return {
            restrict: 'A',
            link: function(scope, elem, attr) {
                var target = attr.target || 'show-on-height-diff-departments';
                var comparer = attr.comparer || 'comparer-object';
                var offset = parseInt(attr.offset) || 2;
                angular.element('.' + target).hide();
                var hasShown = false;

                scope.$watch(function() {
                    if (!hasShown) {
                        return angular.element('.' + comparer).height();
                    }
                    return null;
                }, function() {
                    showFocal();
                });

                function showFocal() {
                    if (!hasShown) {
                        $timeout(function () {
                            var comparerHeight = angular.element('.' + comparer).height();
                            var elemHeight = elem.height();
                            if (comparerHeight > 0 && elemHeight > 0 && (elemHeight - offset) > comparerHeight) {
                                angular.element('.' + target).show();
                                hasShown = true;
                            }
                        });
                    }
                }
            }
        };
    }
})();